<template>
	<SurveyScreen v-bind="surveyData" />
</template>

<script setup>
import { reactive } from '@vue/runtime-core'
import SurveyScreen from '@/components/SurveyScreen'

const surveyData = reactive({
	title: 'When do you typically feel the urge to grab a snack?',
	subtitle: 'Simple uses psychology to understand your eating habits and personalize your plan.',
	property: 'grab_snack',
	options: [
		{ id: 1, label: 'Mornings', value: 'mornings' },
		{ id: 2, label: 'Afternoons', value: 'afternoons' },
		{ id: 3, label: 'Evenings', value: 'evenings' },
		{ id: 4, label: 'Late at night', value: 'late_at_night' }
	],
	eventDone: 'OnboardingGrabASnackScreenDone',
	eventView: 'OnboardingGrabASnackScreen',
	nextRouteName: 'snack-trigger',
	skip: {
		text: 'None of the above',
		key: 'none'
	}
})
</script>
